import React, { useEffect, useRef, useState } from "react";
import '../../assets/stylesheets/Content/home.scss'
import BannerLogo from '../../assets/images/banner_alaia_logo.svg'
import BlogImage1 from '../../assets/images/section_5_blog_1.jpg'
import BlogImage2 from '../../assets/images/section_5_blog_2.jpg'
import BlogImage3 from '../../assets/images/section_5_blog_3.jpg'
import BlogImage4 from '../../assets/images/section_5_blog_4.jpg'
import Slider1Image1 from '../../assets/images/slider_1_img_1.webp'
import Slider1Image2 from '../../assets/images/slider_1_img_2.webp'
import Slider1Image3 from '../../assets/images/slider_1_img_3.webp'
import Slider2Image1 from '../../assets/images/slider_2_img_1.jpg'
import Slider2Image2 from '../../assets/images/slider_2_img_2.jpg'
import Slider2Image3 from '../../assets/images/slider_2_img_3.jpg'
import Slider2Image4 from '../../assets/images/slider_2_img_4.jpg'
import BannerThumbnail from '../../assets/images/banner_alaia_thumbnail.png'
import BannerVideo from '../../assets/images/banner_alaia_video.mp4'
// import Slider2ImageResponsive from '../../assets/images/slider_2_responsive_img_1.svg'
// import Slider2Image2Responsive from '../../assets/images/slider_2_responsive_img_2.svg'
// import Slider2Image3Responsive from '../../assets/images/slider_2_responsive_img_3.svg'
// import Slider2Image4Responsive from '../../assets/images/slider_2_responsive_img_4.svg'
import ContentSlider from "./ContentSlider";
import ContentResponsiveSlider from "./ContentResponsiveSlider";
import { useNavigate } from "react-router-dom";
import LazyLoadedVideo from "./_LazyLoadedVideo";
import LazyLoad from 'react-lazyload';

export default function Home(){

    const navigate = useNavigate();
    const [width, setWidth] = useState(0);
    const content_arr = [
        {content: 'Happiness” is essential to a healthy body. Now more than ever we need to focus on being happy.', author: 'Dr. Aileen Marty M.D. F.A.C.P'},
        {content: 'If you want good learning outcomes, you need to have time built into the school day where educators are allowing students to get through the emotional issues they’re experiencing. Alaia Learn offers a place to work on self-development. ', author: 'Teacher, Mater International Studies'},
        {content: 'Mindfulness has changed the way our students deal with the trauma they come into the classroom working through', author: 'Teacher, Mater International Studies'},
        {content: 'Alaia is helping students become more conscious of not only their physical health, but their mental and emotional health. ', author: 'Teacher, Mater International Studies'},
        {content: 'If you want good learning outcomes, you need to have time built into the school day where educators are allowing students to get through the emotional issues they’re experiencing. Alaia Learn offers a place to work on self-development. ', author: 'Teacher, Mater International Studies'},
        {content: 'Alaia is making students take that time to not only monitor their sleep, practice better health habits and exercise more, but most importantly, it is teaching them to practice their selfcare.', author: 'Teacher, Mater International Studies'},
        {content: 'I would recommend students try Alaia. It helps me feel free and be able to continue my day with a positive view.  ', author: 'Student, Mater International Studies'},
        {content: 'Everytime I do a mindfulness session, I open my eyes and I’m ready to tackle the rest of my day.', author: 'Student, Mater International Studies'}
    ]

    const sliderList =  [Slider1Image1,Slider1Image2,Slider1Image3].map((image,index)=>{
                        return  <LazyLoad key={`slider_1_${index}`}  ><div id={`slider_1_${index}`} className="section_slider_container section_2">
                                    <div className="section_slider_left section_2">
                                        <div className="section_slider_text section_2">
                                        Alaia Wellness promotes healthy daily habits, guiding you through the practice of mindfulness, reflection, sleep, and fitness. Learn to navigate your emotions through the practice of mindfulness, empowering you to embrace self-discovery and personal growth.
                                        </div>
                                        <div className="section_slider_button_container section_2">
                                            <button className="section_slider_button section_2" onClick={()=>{navigate('/wellness')}}>
                                                Learn more
                                            </button>
                                        </div>
                                    </div>
                                    
                                     <div className="section_slider_right section_2" style={{backgroundImage: `url(${image})`}}></div>
                                </div>
                                </LazyLoad>
                        })

    const sliderList2 = [Slider2Image1,Slider2Image2,Slider2Image3,Slider2Image4].map((image,index)=>{
                        return<LazyLoad key={`slider_2_${index}`}  ><div id={`slider_2_${index}`} className="section_slider_container section_3">
                                    <div className="section_slider_left section_3" style={{backgroundImage: `url(${image})`}}></div>
                                    <div className="section_slider_right section_3">
                                        <div className="section_slider_text section_3">
                                        Alaia Learn introduces a first-of-its-kind curriculum, providing students with lessons that extend beyond the classroom to foster happier, healthier, and resilient youth. Crafted collaboratively by students and teachers, our proactive curriculum is rooted in resilience education, cultivating problem-solving skills and positive mindsets.
                                        </div>
                                        <div className="section_slider_button_container section_3">
                                            <button className="section_slider_button section_3" onClick={()=>{navigate('/learn')}}>
                                                Learn more
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                </LazyLoad> 
                            })

    
    const sliderList3 = [];
    for (let i = 0; i < content_arr.length; i += 2) {
        const content1 = content_arr[i];
        const content2 = content_arr[i + 1];
        sliderList3.push(
            <div className="section_slider_container section_4" key={`content_${i}`}>
                <div className="content_section_4_contnent left">
                    <p>{content1.content}</p>
                    <span>{content1.author}</span>
                </div>
                <div className="content_section_4_contnent right">
                    <p>{content2.content}</p>
                    <span>{content2.author}</span>
                </div>
            </div>
        );
    }

    const slider1Responsive =   [Slider1Image1,Slider1Image2,Slider1Image3].map((image,index)=>{
                                return  <LazyLoad key={`slider_1_responsive_${index}`} ><div className="content_section_2_resposive_image_container">
                                            <div id={`slider_1_${index}`} className='content_section_2_image_responsive' style={{backgroundImage: `url(${image})`, height: '100%'}}/>
                                        </div> 
                                        </LazyLoad>
                                })
    // const slider2Responsive =  [Slider2ImageResponsive,Slider2Image2Responsive,Slider2Image3Responsive,Slider2Image4Responsive].map((image,index)=>{
    //                             return <div id={`slider_2_${index}`} className="section_slider_container section_3">
    //                                         <div className="section_slider_left section_3" style={{backgroundImage: `url(${image})`}}></div>
    //                                         <div className="section_slider_right section_3">
    //                                             <div className="section_slider_text section_3">
    //                                             Alaia Learn introduces a first-of-its-kind curriculum, providing students with lessons that extend beyond the classroom to foster happier, healthier, and resilient youth. Crafted collaboratively by students and teachers, our proactive curriculum is rooted in resilience education, cultivating problem-solving skills and positive mindsets.
    //                                             </div>
    //                                             <div className="section_slider_button_container section_3">
    //                                                 <button className="section_slider_button section_3">
    //                                                     Learn more
    //                                                 </button>
    //                                             </div>
    //                                         </div>
    //                                     </div>
                                    
    //                                 })

    const slider3Responsive =   content_arr.map((content_hash,i)=>{
                                return  <div className="section_slider_container section_4_responsive" key={`content_${i}`}>
                                            <div className="content_section_4_contnent responsive">
                                                <p>{content_hash.content}</p>
                                                <span>{content_hash.author}</span>
                                            </div>
                                        </div>
                                })

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };
    
        handleResize();
    
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        document.title = "Alaia | Home";
      }, [])
        
    return <>
        <div className="content_home_wrapper">
            <section className="content_home section_1">
                <div className="responsive_banner_text_container">
                    <p className="responsive_content_section_1">Live Happy.<br/>Be Healthy. <br/>Have Purpose.</p>
                    <p className="banner_text_responsive">A personalized wellness platform curated by educators to achieve happy, healthy, and purposeful lives.</p>
                    <button className="try_alaia home" onClick={()=>{navigate('/sign-up')}}>Try Alaia</button>
                </div>
                <div className="banner_wrapper">
            
                   <LazyLoadedVideo BannerThumbnail={BannerThumbnail} BannerVideo={BannerVideo}/>

                    <div className="banner_container">
                        <div className="responsive_gradient"></div>
                        <div className="banner_content_container"> 
                            <div className="content_section_1_logo"><img src={BannerLogo} alt="logo"/></div>
                            <p className="content_section_1">Live Happy. Be Healthy. Have Purpose.</p>
                            <p className="banner_text">A personalized wellness platform curated by educators to achieve happy, healthy, and purposeful lives.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content_home section_2">
                <div className="content_section_wrapper section_2">
                    <div className="content_section_header_container section_2">
                        <h1>Alaia Wellness | A Lifestyle</h1>
                    </div>
                    <div className="content_section_inner_wrapper section_2">
                        {width > 740 && <div className="content__section__container section_2">
                                <ContentSlider sliderList={sliderList} section={'section_2'}/>
                            </div> }
                            
                        {width <= 740 && <div className="content_section_2_container_responsive">
                            <ContentResponsiveSlider sliderList={slider1Responsive} section={'section_2'}/>
                        </div>}
                    </div>
                    <div className="content_section_2_container_responsive_text_wrapper">
                        <div className="content_section_2_container_responsive_text_container">
                            <div className="content_section_2_container_responsive_text">
                                Alaia Wellness promotes healthy daily habits, guiding you through the practice of mindfulness, reflection, sleep, and fitness. Learn to navigate your emotions through the practice of mindfulness, empowering you to embrace self-discovery and personal growth.
                            </div>
                            <button className="content_section_2_container_responsive_button" onClick={()=>{navigate('/wellness')}}>Learn more</button>
                        </div>
                    </div>
                </div> 
            </section>
            <section className="content_home section_3">
                <div className="content_section_wrapper section_3">
                    <div className="content_section_header_container section_3">
                        <h1>Alaia Learn | A Pathway</h1>
                    </div>
                    <div className="content_section_inner_wrapper section_3">
                        <div className="content__section__container section_3">
                            <ContentSlider sliderList={sliderList2} section={'section_3'}/> 
                        </div>
                    </div>
                    <div className="content_section_2_container_responsive_text_wrapper section_3">
                        <div className="content_section_2_container_responsive_text_container">
                            <div className="content_section_2_container_responsive_text">
                                Alaia Learn introduces a first-of-its-kind curriculum, providing students with lessons that extend beyond the classroom to foster happier, healthier, and resilient youth. Crafted collaboratively by students and teachers, our proactive curriculum is rooted in resilience education, cultivating problem-solving skills and positive mindsets.
                            </div>
                            <button className="content_section_2_container_responsive_button" onClick={()=>{navigate('/learn')}}>Learn more</button>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content_home section_4">
                <div className="content_section_wrapper section_4">
                    <div className="content_section_header_container section_4">
                        <h1>Alaia Stories</h1>
                    </div>
                    <div className="content_section_inner_wrapper section_4">
                        <div className="content__section__container section_4">
                            <ContentSlider sliderList={ width > 740 ? sliderList3 : slider3Responsive} section={'section_4'}/>
                        </div>     
                    </div>
                </div>
            </section>
            <section className="content_home section_5">
                <div className="content_section_wrapper section_5">
                    <div className="content_section_header_container section_5">
                        <h1>Blog</h1>
                    </div>
                    <div className="content_section_inner_wrapper section_5">
                     
                        <div className="content__section__container section_5">
                        <LazyLoad>
                            <div className="content_section_5_grid_item" onClick={()=>{
                                navigate('article/How-to-Break-Up-with-Your-Bad-Habits')
                            }}>
                                <div className="preview_container">
                                    <div className="preview_img" style={{backgroundImage: `url(${BlogImage1})`}}></div>
                                </div>
                                <h4>How to Break Up with Your Bad Habits</h4>
                                <p>By using mindfulness to understand and manage your cravings, you can gradually break free from unwanted habits and regain control over your actions.</p>
                            </div>
                            </LazyLoad>
                            <LazyLoad>
                            <div className="content_section_5_grid_item" onClick={()=>{
                                navigate('article/To-Change-Your-Behavior-Now,-Imagine-Your-Future-Self')
                            }}>
                                <div className="preview_container">
                                    <div className="preview_img" style={{backgroundImage: `url(${BlogImage2})`}}></div>
                                </div>
                                <h4>To Change Your Behavior Now, Imagine Your Future Self</h4>
                                <p>Your identity drives your behavior, which over time creates your personality. So start acting like the best version of yourself, and you will become that person.</p>
                            </div>
                            </LazyLoad>
                            <LazyLoad>
                            <div className="content_section_5_grid_item" onClick={()=>{
                                navigate('article/How-to-Boost-Mental-Health-Through-Better-Nutrition')
                            }}>
                                <div className="preview_container">
                                    <div className="preview_img" style={{backgroundImage: `url(${BlogImage3})`}}></div>
                                    
                                </div>
                                <h4>How to Boost Mental Health Through Better Nutrition</h4>
                                <p>As research progresses, we're uncovering more about how what we eat impacts our minds. The latest findings affirm that our diet plays a crucial role in our psychological well- being.</p>
                            </div>
                            </LazyLoad>
                            <LazyLoad>
                            <div className="content_section_5_grid_item" onClick={()=>{
                                navigate('article/Assessing-the-Association-Between-Lifetime-Exposure-to-Greenspace-and-Early-Childhood-Development')
                            }}>
                                <div className="preview_container">
                                    <div className="preview_img" style={{backgroundImage: `url(${BlogImage4})`}}></div>   
                                </div>
                                <h4>Children who spend lots of time in nature see greater overall development</h4>
                                <p>Exposure to green spaces from a young age is crucial for children's social, emotional, and mental growth.</p>
                            </div>
                            </LazyLoad>
                        </div>
                       
                    </div>
                </div>
            </section>
        </div>
       
    </>

}